module.exports = __webpack_public_path__ + "static/polestar-8c6c71e23bbb3e2c0a9128160b59bda9.png";